import { useNavigate } from "react-router-dom";
import { useFetch } from "../../hooks/useFetch";
import { getInternalPathFromLocation } from "../../lib/routeTokens";

const RedirectToLogin = () => {
  const navigate = useNavigate();

  useFetch(() => {
    const redirect = encodeURIComponent(getInternalPathFromLocation(window.location));
    navigate(`/login?redirect=${redirect}`);
  });
  return <></>;
};
export default RedirectToLogin;
